/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AnsweredCommentsContainer_settings = {
    readonly reaction: {
        readonly sortLabel: string;
    };
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentContainer_settings">;
    readonly " $refType": "AnsweredCommentsContainer_settings";
};
export type AnsweredCommentsContainer_settings$data = AnsweredCommentsContainer_settings;
export type AnsweredCommentsContainer_settings$key = {
    readonly " $data"?: AnsweredCommentsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentsContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnsweredCommentsContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "kind": "LinkedField",
            "name": "reaction",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sortLabel",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AnsweredCommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'c4c5bd2d06ff54c87707379b1e6a6103';
export default node;
